import { on } from 'delegated-events'
import Pristine from 'pristinejs'

const SELECTORS = Selectors({
  form: 'NewsEventsSubscribeForm_NewsEventsSubscribeForm',
  formSuccessMessage: 'form-success-message',
  formErrorMessage: 'form-error-message'
})

const pristineConfig = {
  classTo: 'field',
  errorClass: 'has-error',
  successClass: 'has-success',
  errorTextParent: 'field',
  errorTextTag: 'div',
  errorTextClass: 'text-help'
}

const fn = {
  init: () => {
    on('submit', SELECTORS.asId('form'), fn.handleSubmit)
  },

  handleSubmit: (e) => {
    e.preventDefault()

    const $form = e.target

    const pristine = new Pristine($form, pristineConfig)

    const valid = fn.validateCustom($form) && pristine.validate()

    if (!valid) {
      const $firstError = $form.querySelector('.field.has-error')

      if ($firstError) {
        $firstError.querySelector('input').focus()
      }

      return false
    }

    const $errorMessage = $form.querySelector(SELECTORS.asClass('formErrorMessage'))
    $errorMessage.style.display = 'none'

    const $successMessage = $form.querySelector(SELECTORS.asClass('formSuccessMessage'))
    $successMessage.style.display = 'none'

    const $submitButton = $form.querySelector('[type=submit]')
    $submitButton.disabled = true
    $submitButton.classList.add(SELECTORS.loading)

    const formData = new FormData($form)

    $.ajax({
      type: 'post',
      url: $form.action,
      data: formData,
      dataType: 'json',
      processData: false,
      contentType: false,
      success: resp => {
        if (resp.success) {
          $successMessage.textContent = resp.message
          $successMessage.style.display = 'block'

          $form.querySelectorAll('[type=checkbox]:checked').forEach(i => i.checked = false)
          $form.querySelector('[type=email]').value = null
        } else {
          $errorMessage.innerHTML = resp.message
          $errorMessage.style.display = 'block'
        }
      },
      error: () => {
        $errorMessage.innerHTML = 'Sorry, there was a problem with your submission'
        $errorMessage.style.display = 'block'
      },
      complete: () => {
        $submitButton.disabled = false
        $submitButton.classList.remove(SELECTORS.loading)
      }
    })

    return valid
  },

  validateCustom: ($form) => {
    let valid = true

    const $choices = $form.querySelector('#NewsEventsSubscribeForm_NewsEventsSubscribeForm_SubscribeType_Holder')

    $choices.querySelectorAll('.pristine-error').forEach(i => i.remove())
    $choices.classList.remove('has-error')

    if (!$choices.querySelector('[type=checkbox]:checked')) {
      valid = false
      $choices.classList.add('has-error')
      valid = false

      const $errorEl = document.createElement('div')
      $errorEl.className = 'pristine-error'
      $errorEl.innerHTML = 'Please select an option'
      $choices.appendChild($errorEl)
    }

    return valid
  }
}

export default {
  can: () => true,
  run: fn.init
}
